import React, { useState } from "react";
import styled from "styled-components";
import { RebelColors, RebelModal, RebelModalHeader, RebelModalBody, RebelModalFooter, RebelAccentButton, RebelSecondaryButton, RebelSelect, RebelLabel } from "../../../styles/rebel-experiences";

const RebelBudgetAddModal = ({ isOpen, toggle, villaList, existingProperties, onAdd }) => {
    const [selectedVilla, setSelectedVilla] = useState("");

    // Filter out already-added properties
    const availableVillas = villaList.filter(v => {
        const villaId = v.id || v._docId;
        return !existingProperties.includes(villaId);
    });

    const handleAdd = () => {
        if (selectedVilla) {
            onAdd(selectedVilla);
            setSelectedVilla("");
        }
    };

    const handleToggle = () => {
        setSelectedVilla("");
        toggle();
    };

    return (
        <RebelModal isOpen={isOpen} toggle={handleToggle}>
            <RebelModalHeader toggle={handleToggle}>Add Property</RebelModalHeader>
            <RebelModalBody>
                <RebelLabel>Select a Property</RebelLabel>
                <RebelSelect
                    value={selectedVilla}
                    onChange={e => setSelectedVilla(e.target.value)}
                >
                    <option value="">Choose a property...</option>
                    {availableVillas.map(villa => {
                        const villaId = villa.id || villa._docId;
                        const name = villa.villaName || villa.name || "Unnamed Property";
                        const location = villa.location || "";
                        return (
                            <option key={villaId} value={villaId}>
                                {name}{location ? ` — ${location}` : ""}
                            </option>
                        );
                    })}
                </RebelSelect>

                {availableVillas.length === 0 && (
                    <NoPropertiesText>
                        {villaList.length === 0
                            ? "Loading properties..."
                            : "All available properties have been added."}
                    </NoPropertiesText>
                )}
            </RebelModalBody>
            <RebelModalFooter>
                <RebelSecondaryButton onClick={handleToggle}>Cancel</RebelSecondaryButton>
                <RebelAccentButton onClick={handleAdd} disabled={!selectedVilla}>
                    Add Property
                </RebelAccentButton>
            </RebelModalFooter>
        </RebelModal>
    );
};

export default RebelBudgetAddModal;

const NoPropertiesText = styled.p`
    color: ${RebelColors.textMuted};
    font-style: italic;
    text-align: center;
    margin-top: 1rem;
`;
